// Note.styled.ts

import styled from "styled-components";

import { Button as ShadButton, ButtonProps } from "@/components/ui/button";
import {
    Card as ShadCard,
    CardContent as ShadCardContent,
    CardFooter as ShadCardFooter,
    CardHeader as ShadCardHeader,
    CardTitle as ShadCardTitle,
} from "@/components/ui/card";
import { Input as ShadInput } from "@/components/ui/input";
import { colourScheme } from "@/utils/styling/colours";

export const Card = styled(ShadCard)`
    width: 100%;
    max-width: 64rem;
    margin: 0 auto;
    color: ${colourScheme.white};
`;

export const CardContent = styled(ShadCardContent)`
    flex-grow: 1;
    overflow: auto;
    padding: 0;
`;

export const CardHeader = styled(ShadCardHeader)`
    flex-shrink: 0;
`;

export const CardTitle = styled(ShadCardTitle)`
    /* Additional styles if needed */
`;

export const CardFooter = styled(ShadCardFooter)`
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    flex-wrap: wrap;
`;

export const Toolbar = styled.div`
    top: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    width: fit-content;
    padding: 0.5rem;
    background: ${colourScheme.primaryDark};
`;

export const EditorContainer = styled.div`
    min-height: 200px;
    padding: 1rem;
    background: ${colourScheme.primaryLight};
    color: ${colourScheme.white};

    .ProseMirror {
        outline: none;
    }
`;

export const LoadingContainer = styled(CardContent)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16rem;
`;

export const Spinner = styled.div`
    animation: spin 1s linear infinite;
    border-radius: 9999px;
    height: 8rem;
    width: 8rem;
    border-bottom: 2px solid ${colourScheme.secondary};

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;

interface StyledButtonProps extends ButtonProps {
    active?: boolean;
}

export const StyledButton = styled(ShadButton)<StyledButtonProps>`
    background: ${({ active }) =>
        active ? colourScheme.secondaryDark : colourScheme.primaryLight};
    color: ${colourScheme.white};
    border: 1px solid ${colourScheme.greyLight};

    &:hover {
        background: ${colourScheme.secondaryDark};
    }
`;

export const SaveButton = styled(ShadButton)`
    background: ${colourScheme.secondary};
    color: ${colourScheme.white};

    &:hover {
        background: ${colourScheme.secondaryDark};
    }
`;

export const LastSavedText = styled.div`
    color: ${colourScheme.greyLight};
`;

export const WordCountText = styled.div`
    color: ${colourScheme.greyLight};
`;

export const TagButton = styled(ShadButton)`
    background: ${colourScheme.secondaryLight};
    color: ${colourScheme.primaryDark};

    &:hover {
        background: ${colourScheme.secondary};
        color: ${colourScheme.white};
    }
`;

export const Input = styled(ShadInput)`
    background: ${colourScheme.primaryLight};
    color: ${colourScheme.white};
    border: 1px solid ${colourScheme.greyLight};
`;

export const BubbleMenuButton = styled(ShadButton)<StyledButtonProps>`
    background: ${({ active }) =>
        active ? colourScheme.secondaryDark : colourScheme.secondary};
    color: ${colourScheme.white};

    &:hover {
        background: ${colourScheme.secondaryDark};
    }
`;
